import React, { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserAvatar } from 'pisaka-ui';
import styles from './headerComponent.module.css';
import { fontCreatorPageUrl, profilePageUrl } from '../../../helpers/urls';

interface User {
  id: number;
  name?: string;
  email: string;
}

type PropsType = {
  toggleSidebar: () => void;
  user?: User;
};

const HeaderComponent: FC<PropsType> = ({ toggleSidebar, user }) => {
  const navigate = useNavigate();

  const handleAvatarClick = () => {
    navigate(profilePageUrl);
  };

  return (
        <div className={styles.container}>
            <div className="flex items-center">
                <div className="flex flex-col justify-between h-[42px] w-[42px] py-[12px] px-[6px] cursor-pointer relative" onClick={toggleSidebar}>
                    <div className="w-full h-[3px] bg-black" />
                    <div className="w-full h-[3px] bg-black" />
                    <div className="w-full h-[3px] bg-black" />
                    <div className="absolute h-[6px] w-[6px] bg-danger top-[10px] right-[4px] rounded-3" />
                </div>
                <div className={styles.flex}>
                    <a href="/" className={styles.logo}></a>
                </div>
            </div>
            <div className={styles.flex}>
                {user && +user.id ? (
                    <UserAvatar
                        user={user}
                        size="sm"
                        showName={true}
                        onClick={handleAvatarClick}
                        className="text-primary2 hover:text-primary"
                    />
                ) : (
                    <a href={fontCreatorPageUrl} className="text-14 block text-primary2 text-right leading-18">
                        Создать свой рукописный шрифт
                    </a>
                )}
            </div>
        </div>
  );
};

export default HeaderComponent;
